import * as React from 'react'

import { Box } from '~ui/components/layout/Box'

type TBoxProps = Pick<
  PropsOf<typeof Box>,
  | 'opacity'
  | 'bgColor'
  | 'radius'
  | 'padding'
  | 'shadow'
  | 'border'
  | 'width'
  | 'maxWidth'
  | 'minWidth'
  | 'maxHeight'
  | 'minHeight'
  | 'height'
  | 'position'
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'display'
  | 'flex'
  | 'flexBasis'
  | 'flexDirection'
  | 'flexGrow'
  | 'flexShrink'
  | 'alignContent'
  | 'alignItems'
  | 'alignSelf'
  | 'flexWrap'
  | 'justifySelf'
  | 'justifyItems'
  | 'justifyContent'
  | 'order'
  | 'gap'
  | 'columnGap'
  | 'rowGap'
  | 'gridColumnStart'
  | 'gridColumnEnd'
  | 'gridColumn'
  | 'gridRow'
  | 'gridAutoFlow'
  | 'gridAutoColumns'
  | 'gridAutoRows'
  | 'gridTemplateColumns'
  | 'gridTemplateRows'
  | 'gridTemplateAreas'
  | 'gridArea'
  | 'placeItems'
  | 'overflow'
  | 'cursor'
  | 'onClick'
  | 'as'
  | 'zIndex'
  | 'id'
>

type TProps = RequiredChildren & TBoxProps & TestingProps

/**
 * Basic stand-out content component wrapping it’s children in colored box adding some box shadow, radius etc.
 * It also automatically figures out text color with appropriate contrast.
 */
export const Card: React.FC<TProps> = ({
  bgColor,
  children,
  shadow = `light`,
  radius = `small`,
  padding = `medium`,
  dataTestId,
  ...boxProps
}) => {
  return (
    <Box
      {...boxProps}
      dataTestId={dataTestId}
      padding={padding}
      radius={radius}
      bgColor={bgColor}
      shadow={shadow}
    >
      {children}
    </Box>
  )
}
